import type { Component } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

import { DOCTYPES } from '@/constants/doctypes.ts'
import { PERMISSIONS } from '@/constants/permissions.ts'

import { routeCustomerRoot } from './routeOrganizationDetail/customer'
import { routeInvestorRoot } from './routeOrganizationDetail/investor'
import { routeOtherRoot } from './routeOrganizationDetail/other'
import { routePartnerRoot } from './routeOrganizationDetail/partner'
import { routeSalesPartnerRoot } from './routeOrganizationDetail/salesPartner'
import { routeSupplierRoot } from './routeOrganizationDetail/supplier'

const organisationViewDoctypes = {
  [DOCTYPES.BANK]: [PERMISSIONS.READ], // bank = investor
  [DOCTYPES.CONTACT]: [PERMISSIONS.READ],
  [DOCTYPES.CUSTOMER]: [PERMISSIONS.READ],
  [DOCTYPES.EVENT]: [PERMISSIONS.READ],
  [DOCTYPES.SALES_PARTNER]: [PERMISSIONS.READ],
  [DOCTYPES.SUPPLIER]: [PERMISSIONS.READ],
  [DOCTYPES.TAG]: [PERMISSIONS.SELECT],
  [DOCTYPES.TW_ACTIVITY_DOCUMENTATION]: [PERMISSIONS.READ],
  [DOCTYPES.TW_OTHER]: [PERMISSIONS.READ],
  [DOCTYPES.TW_PARTNER]: [PERMISSIONS.READ],
  [DOCTYPES.TW_ROLE]: [PERMISSIONS.READ],
}

const routeOrganizationsHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/views/relations/OrganizationsView.vue')
  },
  meta: {
    doctypes: organisationViewDoctypes,
  },
  name: 'organizations-home',
  path: '',
}

const routeOrganizationsFavoritesHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/views/relations/OrganizationsView.vue')
  },
  meta: {
    doctypes: organisationViewDoctypes,
  },
  name: 'organizations-favorites-home',
  path: 'favorites',
}

const routeOrganizationsCustomersHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/views/relations/OrganizationsView.vue')
  },
  meta: {
    doctypes: organisationViewDoctypes,
  },
  name: 'organizations-customers-home',
  path: 'customers',
}

const routeOrganizationsSuppliersHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/views/relations/OrganizationsView.vue')
  },
  meta: {
    doctypes: organisationViewDoctypes,
  },
  name: 'organizations-suppliers-home',
  path: 'suppliers',
}

const routeOrganizationsPartnersHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/views/relations/OrganizationsView.vue')
  },
  meta: {
    doctypes: organisationViewDoctypes,
  },
  name: 'organizations-partners-home',
  path: 'partners',
}

const routeOrganizationsSalesPartnersHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/views/relations/OrganizationsView.vue')
  },
  meta: {
    doctypes: organisationViewDoctypes,
  },
  name: 'organizations-sales-partners-home',
  path: 'sales-partners',
}

const routeOrganizationsInvestorsHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/views/relations/OrganizationsView.vue')
  },
  meta: {
    doctypes: organisationViewDoctypes,
  },
  name: 'organizations-investors-home',
  path: 'investors',
}

const routeOrganizationsOthersHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/views/relations/OrganizationsView.vue')
  },
  meta: {
    doctypes: organisationViewDoctypes,
  },
  name: 'organizations-others-home',
  path: 'others',
}

const routeOrganizationsRoot: RouteRecordRaw = {
  children: [
    routeOrganizationsHome,
    routeOrganizationsFavoritesHome,
    routeOrganizationsCustomersHome,
    routeOrganizationsSuppliersHome,
    routeOrganizationsPartnersHome,
    routeOrganizationsSalesPartnersHome,
    routeOrganizationsInvestorsHome,
    routeOrganizationsOthersHome,
    routeCustomerRoot,
    routeInvestorRoot,
    routeOtherRoot,
    routeSalesPartnerRoot,
    routeSupplierRoot,
    routePartnerRoot,
  ],
  path: 'organizations',
}

export {
  routeOrganizationsCustomersHome,
  routeOrganizationsFavoritesHome,
  routeOrganizationsHome,
  routeOrganizationsInvestorsHome,
  routeOrganizationsOthersHome,
  routeOrganizationsPartnersHome,
  routeOrganizationsRoot,
  routeOrganizationsSalesPartnersHome,
  routeOrganizationsSuppliersHome,
}
